import { useEffect } from 'react';

function useAppleLogin({ onSuccess }) {
  function loadScript(d, s, id, jsSrc, cb, onError) {
    const element = d.getElementsByTagName(s)[0];
    const fjs = element;
    let js = element;
    js = d.createElement(s);
    js.id = id;
    js.src = jsSrc;
    if (fjs && fjs.parentNode) {
      fjs.parentNode.insertBefore(js, fjs);
    } else {
      d.head.appendChild(js);
    }
    js.onerror = onError;
    js.onload = cb;
  }

  useEffect(() => {
    if (!window.AppleID) {
      loadScript(
        document,
        'script',
        'apple-login',
        'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
        () => {
          window.AppleID.auth.init({
            clientId: 'io.invideo.web',
            scope: 'name email',
            redirectURI:
              'https://feature-applelogin.d1pxani3440r38.amplifyapp.com',
            usePopup: true, //or false defaults to false
          });
        },
        err => {
          console.error(err);
        },
      );
      document.addEventListener('AppleIDSignInOnSuccess', data => {
        // console.log('===SignIn success===', data);
        const formData = {
          email: data.detail.user?.email,
          full_name: data.detail.user
            ? data.detail.user.name.firstName + data.detail.user.name.lastName
            : undefined,
          uid: data.detail.authorization.id_token,
          referrer: 'website',
          page_source: window.location.href,
          device_id: window.deviceId || '',
          route: 'apple',
        };
        onSuccess(formData);
      });

      //Listen for authorization failures
      document.addEventListener('AppleIDSignInOnFailure', error => {
        console.info('SignIn failure', error);
      });
    }
  }, [onSuccess]);

  function appleLogin() {
    window.AppleID.auth.signIn();
  }

  return { appleLogin };
}

export default useAppleLogin;
